
const eventState = {
	NONE: "NONE", // placeholder state, not actually persisted
	CREATED: "CREATED", // meeting created, but not started
	MEETING_STARTED: "MEETING_STARTED", // meeting started
	MEETING_ENDED: "MEETING_ENDED", // meeting ended, but not finalized (no feedback report)
	MEETING_COMPLETED: "MEETING_COMPLETED", // meeting finalized (with feedback report)
};

export default Object.freeze( eventState );



// WEBPACK FOOTER //
// ./src/constants/EventState.js